// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import { Chart, registerables } from 'chart.js'
import Choices from 'choices.js'
import flatpickr from "flatpickr";
import InfiniteHorzScroll from '@kreonovo/infinitescroll/dist/index.js'

window.InfiniteHorzScroll = InfiniteHorzScroll;
// Register Chart.js components
Chart.register(...registerables);

// Make libraries available globally
window.bootstrap = bootstrap
window.Choices = Choices
window.Chart = Chart
window.flatpickr = flatpickr
window.setJodit = setJodit
window.setChoices = setChoices

document.addEventListener('turbo:load', () => {
  setChoices()
  setJodit()
  setCharts()
  setTooltips()
  setFlatpicker()

  let imageWrapper = document.getElementById('imageWrapper');
  if (imageWrapper && imageWrapper.parentElement.hasAttribute('data-scroller-container')) imageWrapper = undefined;
  
  if (imageWrapper) {
    const options = {
      duration: 16, // duration in seconds which will determine the scrolling speed
      disableMask: false, // optional, defaults to false
      direction: 'left' // optional, defaults to 'left'
    };

    const scroller = new InfiniteHorzScroll(imageWrapper, options);
  }
})


document.addEventListener('turbo:frame-load', () => {
  setChoices()
  setJodit()
  setCharts()
  setTooltips()
  setFlatpicker()
})

document.addEventListener('turbo:render', () => {
  setChoices()
  setJodit()
  setTooltips()
  setFlatpicker()
})

let joditModulePromise
// 
function ensureJoditStylesheet () {
  if (document.getElementById('jodit-styles')) return
  const link = document.createElement('link')
  link.id = 'jodit-styles'
  link.rel = 'stylesheet'
  link.href = 'https://cdn.jsdelivr.net/npm/jodit@4.6.2/es2021/jodit.min.css'
  document.head.appendChild(link)
}

function loadJodit () {
  if (window.Jodit) return Promise.resolve(window.Jodit)
  if (!joditModulePromise) {
    ensureJoditStylesheet()
    joditModulePromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://cdn.jsdelivr.net/npm/jodit@4.6.2/es2021/jodit.fat.min.js'
      script.async = true
      script.onload = () => resolve(window.Jodit)
      script.onerror = () => reject(new Error('Jodit failed to load'))
      document.head.appendChild(script)
    })
  }
  return joditModulePromise
}

function setChoices() {
  let selects = document.querySelectorAll('select')
  
  selects.forEach((select) => {
    new Choices(select, {
      position: 'bottom',
      itemSelectText: '',
      noResultsText: '',
    })
  })
}

async function setJodit() {
  let joditButtons = ["bold", "italic", "underline", "paragraph", "ul", "ol", "indent", "outdent", "align", "image", "link", "brush"]

  let csrfToken = document.querySelector('meta[name="csrf-token"]').content

  let joditConfig = {
      placeholder: '',
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      defaultActionOnPaste: 'insert_only_text',
      processPasteHTML: false,
      // Do not force images to 300px width; keep natural size.
      imageDefaultWidth: null,
      uploader: {
        url: '/uploads',
        insertImageAsBase64URI: false,
        headers: { 'X-CSRF-Token': csrfToken }
      },
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      maxHeight: 400,
      buttonsXS: joditButtons,
      buttonsSM: joditButtons,
      buttonsMD: joditButtons,
      buttons: joditButtons
  }

  let textareas = document.querySelectorAll('textarea.jodit')

  if (!textareas.length) { return }

  const Jodit = await loadJodit()

  textareas.forEach((textarea) => {
    textarea.classList.remove('jodit')
    new Jodit(textarea, joditConfig)
  })
}

function setCharts() {
  const chart = document.querySelector('canvas')

  if (!chart) { return null}

  const ctx = chart.getContext('2d')
  const myChart = new Chart(ctx, {
      type: 'doughnut',
      data: {
          datasets: [{
              data: JSON.parse(chart.dataset['data']),
              backgroundColor: [
                  '#00a75a',
                  '#d75b67',
                  '#6c757d'
              ]
          }]
      },
      options: {
        plugins: {
          tooltip: { 
            enabled: false
          }
        },
        responsive: true,
        scales: {
          x: {
            display: false
          },
          y: {
            display: false
          }
        }
      }
  });
}

function setTooltips() {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })
}

function setFlatpicker() {
  flatpickr('[type="datetime-local"]', {
    enableTime: true,
    noCalendar: false,
    dateFormat: "d.m.Y H:i",
    time_24hr: true,
    disableMobile: "true",
    onReady: function() {
      this.setDate(this._input.getAttribute('value'))
    }
  })

  flatpickr('[type="date"]', {
    noCalendar: false,
    dateFormat: "d.m.Y",
    disableMobile: "true",
    onReady: function() {
      this.setDate(this._input.getAttribute('value'))
    }
  })
}
